export interface pi2claims {
    pp: string;
    push: string;
    email: string;
    db: string;
    fullName: string;
    userId: string;
    officeId: string;
    language: string;
    isPreview?: boolean;
}

export enum Scope {
    Purpose = "scopedAccess",
    InvoicePreview = "invoice",
    SchoolClaim = "schoolClaim",
    SignPackages = "signPackages",
    Preview = "preview",
    Tariffication = "tariffication",
    Color = "color",
    DataVerificationCompany = "dataVerificationMoralPerson",
}

export interface TokenPayload {
    nbf: number;
    exp: number;
    iss: string;
    aud: string;
    sub: string;
    iat: number;
    jti: string;
    scope: Scope;
    "pi2.claims": pi2claims;
}
